<template>
  <div id="payment-category" class="payment-category py-i">
    <div class="row px-i payment-section">
      <div class="highlighted-section">
        <div class="px-i highlighted-section-row">
          <div class="highlighted-section-row-start">
            <div class="highlighted-section-row-start-text">
              Invoice Balance
            </div>
          </div>
          <div class="highlighted-section-row-end">
            {{ invoiceTotal | formatCurrency(currencyIsoCode, currencyMinimumDigits) }}
          </div>
        </div>
        <div v-if="passOnFawterFee" class="px-i highlighted-section-row">
          <div class="highlighted-section-row-start">
            <div class="highlighted-section-row-start-text">
              Fawter Fee
            </div>
          </div>
          <div v-if="paymentMethod" class="highlighted-section-row-end">
            {{ paymentMethodPaymentFees.customer_fawter_fee | formatCurrency(currencyIsoCode, currencyMinimumDigits) }}
          </div>
        </div>
        <div v-show="showPaymentFee" class="px-i highlighted-section-row">
          <div class="highlighted-section-row-start">
            <div class="highlighted-section-row-start-text">
              Payment Fee
            </div>
          </div>
          <div v-if="paymentMethod" class="highlighted-section-row-end">
            {{ paymentMethodPaymentFees.customer_payment_fee | formatCurrency(currencyIsoCode, currencyMinimumDigits) }}
          </div>
        </div>
        <div class="px-i highlighted-section-row">
          <div class="highlighted-section-row-start">
            <div class="highlighted-section-row-start-text">
              Total
            </div>
          </div>
          <div v-if="paymentMethod" class="highlighted-section-row-end highlighted-section-row-end-bold">
            {{ paymentMethodPaymentFees.payment_total | formatCurrency(currencyIsoCode, currencyMinimumDigits) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaymentDetailsTable",

  props: {
    paymentMethod: { type: Object },
    paymentFees: { type: Object },
    currencyIsoCode: { type: String },
    invoiceTotal: { type: [Number, String] },
    passOnFawterFee: { type: Boolean }
  },

  computed: {
    showPaymentFee () {
      return (this.paymentMethod.plugin !== 'Offline') && this.paymentFees[this.paymentMethod.id];
    },

    paymentMethodPaymentFees () {
      return this.paymentFees[this.paymentMethod.id];
    },

    currencyMinimumDigits () {
      return  (this.currencyIsoCode === "LBP") ? 0 : 2;
    },
  },
}
</script>
